
// const singletonId = Symbol();
// const singletonEnforcer = Symbol();

class SettingModel {
  constructor(options) {

    //constructor(enforcer) {
    //if (enforcer !== singletonEnforcer) throw new Error('SettingModel can not use construct. use getInstance method');

    const _ = this;

    _.isLogin = false;
    _.DEVICE_TYPE = 'pc';
    _.DEFAULT_SERVER_ID = 1;
    _.DEFAULT_GENDER = 'MALE';

    _.ITEM_NAMES = {
      'weapon': '무기',
      'helmet': '투구',
      'armor': '갑옷',
      'cape': '망토 ',
      'gloves': '장갑',
      'boots': '부츠',
      'legging': '각반',
      'shield': '방패/가더',
      'belt': '벨트',
      'necklace': '목걸이',
      'ring': '반지',
      'shoulder': '견갑'
    };
    _.CLASS_NAMES = {
      '0': '군주',
      '1': '기사',
      '2': '요정',
      '3': '마법사',
      '4': '다크엘프',
      '5': '용기사',
      '6': '환술사',
      '7': '전사',
      '8': '검사',
      '9': '창기사',
      '10': '성기사'
    };
    _.ACQUISITION_NAMES = {
      'Quest': '퀘스트',
      'NPC': 'NPC 판매',
      'Making': '제작',
      'Drop': '드랍'
    };
    _.CLASS_MAGIC_POWERBOOK = {
      '0': '/powerbook/wiki/%EA%B5%B0%EC%A3%BC%20%EB%A7%88%EB%B2%95',
      '1': '/powerbook/wiki/%EA%B8%B0%EC%82%AC%20%EA%B8%B0%EC%88%A0',
      '2': '/powerbook/wiki/%EC%A0%95%EB%A0%B9%20%EB%A7%88%EB%B2%95',
      '3': '/powerbook/wiki/%EC%9D%BC%EB%B0%98%20%EB%A7%88%EB%B2%95',
      '4': '/powerbook/wiki/%ED%9D%91%EC%A0%95%EB%A0%B9%20%EB%A7%88%EB%B2%95',
      '5': '/powerbook/wiki/%EC%9A%A9%EA%B8%B0%EC%82%AC%20%EB%A7%88%EB%B2%95',
      '6': '/powerbook/wiki/%ED%99%98%EC%88%A0%EC%82%AC%20%EB%A7%88%EB%B2%95',
      '7': '/powerbook/wiki/%EC%A0%84%EC%82%AC%20%EA%B8%B0%EC%88%A0',
      '8': '/powerbook/wiki/%EA%B2%80%EC%82%AC+%EA%B8%B0%EC%88%A0',
      '9': '/powerbook/wiki/%EC%B0%BD%EA%B8%B0%EC%82%AC+%EA%B8%B0%EC%88%A0',
      '10': '/powerbook/wiki/%EC%84%B1%EA%B8%B0%EC%82%AC%20%EA%B8%B0%EC%88%A0'
    };
    _.BOSS_NAMES = {
      '1': '말하는섬',
      '2': '글루디오 던전',
      '3': '고대 정령의 무덤',
      '4': '풍룡의 둥지',
      '5': '상아탑',
      '6': '오렌 설벽',
      '7': '기란 감옥',
      '8': '용의 계곡',
      '9': '화룡의 둥지',
      '10': '오만의 탑',
      '11': '지배의 탑',
      '12': '사막',
      '13': '기타 필드 보스'
    };

    _.ObjectKeys = function(obj) {
        let keys = [];

        for (let i in obj) {
          if (obj.hasOwnProperty(i)) {
            keys.push(i);
          }
        }
        return keys;
      };

    _.ObjectValues = function(obj) {
      let values = [];
        for (let i in obj) {
          if (obj.hasOwnProperty(i)) {
            values.push(obj[i]);
          }
        }
        return values;
      };


  }

}

export default SettingModel;



// WEBPACK FOOTER //
// ./_src/js/service/beginner/tpl.js